

export default (state = {}, action) => {
  if (action.type == "SET_ORGINFO") {
    return action.value;
  }
  return state;
};